import React from 'react';
import banner1 from "../../assets/subbanner/construction-concept-with-engineering-tools.jpg";
import banner from "../../assets/banner/aboutimage.jpeg";
import land from "../../assets/newservicesimge/c1.jpg";
import land1 from "../../assets/newservicesimge/c2.jpeg";
import land3 from "../../assets/servicesimages/TK2.jpg";
import land4 from "../../assets/newservicesimge/c4.jpeg";
import "./construction.css";



function Construction() {
    return (
        <>
            <section>
                <div className="image-all-banner">
                    <img src={banner1} alt="About Us" className="image-bg-all" />
                    <div className="overlay-all-page">
                        <h2 className="fade-in-text">Construction</h2>
                    </div>
                </div>
            </section>

            <section>
                <div className='container mt-5'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className="section-title clearfix ">
                                <div class="title-header">
                                    <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>Construction</h5>
                                    <h3 id="land-development">Land Development & Layout Planning</h3>                                </div>
                                <div className='underline'></div>
                                <p>We offer comprehensive land development services that transform raw, undeveloped land into structured and value-driven assets. Our team handles everything from topographical analysis and feasibility studies to road network design, drainage, and utility planning. With a focus on maximizing land use and adhering to local regulations, we create well-planned layouts that are both practical and aesthetically appealing, catering to residential, commercial, and mixed-use purposes.</p>
                            </div>
                            <h1> </h1>
                        </div>


                        <div className='col-md-6'>
                            <div className='image-container-right'>
                                <img src={land} className='image-container-inside' />
                            </div>
                        </div>
                    </div>

                </div>

                <div className='container mt-5'>
                    <div className='row'>
                        <div className='col-md-6 order-2  order-md-1'>
                            <div className='image-container-right '>
                                <img src={land1} className='image-container-inside' />
                            </div>

                        </div>


                        <div className='col-md-6 order-1  order-md-2'>
                            <div className="section-title clearfix ">
                                <div class="title-header">
                                    <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>Construction</h5>
                                    <h3 id="industrial-planning">Industrial & Factory Land Planning</h3>                                </div>
                                <div className='underline'></div>
                                <p>Industrial land planning requires a deep understanding of zoning laws, logistics, utilities, and safety requirements. We specialize in developing land specifically for industrial use, including factories, warehouses, and manufacturing units. Our services include site selection, layout planning for maximum operational efficiency, and infrastructure setup to support large-scale operations. We help clients set the foundation for successful industrial growth.</p>
                            </div>

                        </div>
                    </div>

                </div>


                <div className='container mt-5'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className="section-title clearfix ">
                                <div class="title-header">
                                    <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>Construction</h5>
                                    <h3 id="turnkey">Turnkey Construction Solutions</h3>                                </div>
                                <div className='underline'></div>
                                <p>Our turnkey construction service offers end-to-end project execution, covering every stage from concept design and planning approvals to construction and final delivery. Clients can rely on a single point of contact throughout the project, ensuring consistent quality, cost control, and timely completion. Whether it's a residential building, commercial complex, or industrial facility, we manage every detail so you can focus on your vision while we build it.</p>
                            </div>
                            <h1> </h1>
                        </div>


                        <div className='col-md-6'>
                            <div className='image-container-right'>
                                <img src={land3} className='image-container-inside' />
                            </div>
                        </div>
                    </div>

                </div>
                <div className='container mt-5'>
                    <div className='row'>
                        <div className='col-md-6 order-2  order-md-1'>
                            <div className='image-container-right'>
                                <img src={land4} className='image-container-inside' />
                            </div>
                        </div>

                        <div className='col-md-6 order-1  order-md-2'>
                            <div className="section-title clearfix ">
                                <div class="title-header">
                                    <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>Construction</h5>
                                    <h3 id="custom-planning">Custom Land Planning & Architectural Design</h3>                                </div>
                                <div className='underline'></div>
                                <p>Every piece of land has unique potential, and our custom planning and design service brings that vision to life. We collaborate closely with clients to understand their requirements and create master plans, building layouts, and architectural designs that are innovative, functional, and regulation-compliant. Whether it's a residential enclave, a commercial space, or a mixed-use development, our solutions are tailored to optimize both aesthetics and functionality.</p>
                            </div>
                            <h1> </h1>
                        </div>



                    </div>

                </div>

            </section>

        </>
    )
}

export default Construction;
